var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tower"},[(_vm.page.enableYotpoRewards)?_c('yotpo-rewards-init'):_vm._e(),_c('blocks-list',{attrs:{"blocks":_vm.page.blocks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }